import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import "./LeadCommentModelCss.css";
import axios from "axios";
import NotifyMessageNoReload from "../../Others/NotifyMessageNoReload";
import { useAuth } from "../../../Store/AuthContext";
import OTPComponent from "../../Login-Signup/OTPComponent";

const SiteUrl = process.env.REACT_APP_SITEURL;
const WebsiteAPIurl = SiteUrl + "api/Webapi/";

export default function VerifyEmailModel({
  open,
  handleClose,
  updatetype,
  verifystatus,
  value,
}) {
  const { userID, RendomTokenfetch } = useAuth();

  const [verifyValue, setVerifyValue] = useState("");
  const [ViewVerify, setViewVerify] = useState(false);
  const [otp, setOTP] = useState("");

  const handleEnterOTP = (otp) => setOTP(otp);

  useEffect(() => {
    setVerifyValue(value || "");
  }, [value]);

  const handaleGenerate = (event) => {
    event.preventDefault();
    // if (verifyValue !== "") {
    //   setViewVerify(true);
    // }

    let fdata = new FormData();
    fdata.append("user_id", userID);
    fdata.append("value", verifyValue);
    fdata.append("verifystatus", verifystatus); // verify or Update
    fdata.append("updatetype", updatetype); // 'email' or 'number'
    if (verifyValue) {
      axios
        .post(`${WebsiteAPIurl}email_number_update_verify`, fdata, {
          headers: {
            Authorization: RendomTokenfetch,
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          console.log(response.data);
          if (verifyValue) {
            if (response.data.status === "1") {
              setViewVerify(true);
              NotifyMessageNoReload(response.data.message, "success");
            } else {
              setViewVerify(false);
              handleClose(); // Close modal on success
              NotifyMessageNoReload(response.data.message, "danger");
            }
          } else {
            NotifyMessageNoReload("Please Fill the Value", "danger");
            console.log("error");
          }
        });
    } else {
      NotifyMessageNoReload("Please Fill the Value", "danger");
      console.log("error");
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    let fdata = new FormData();
    fdata.append("user_id", userID);
    fdata.append("otp", otp);
    fdata.append("value", verifyValue);
    fdata.append("verifystatus", verifystatus);
    fdata.append("updatetype", updatetype);
    if (verifyValue && otp) {
      axios
        .post(`${WebsiteAPIurl}verifyOtp`, fdata, {
          headers: {
            Authorization: RendomTokenfetch,
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          if (verifyValue) {
            if (response.data.Status === "1") {
              setViewVerify(false);
              NotifyMessageNoReload(response.data.msg, "success");
              handleClose(); // Close modal on success
            } else {
              NotifyMessageNoReload(response.data.msg, "danger");
            }
          } else {
            NotifyMessageNoReload("Please Fill the Value", "danger");
            console.log("error");
          }
        });
    } else {
      NotifyMessageNoReload("Please Fill the Value", "danger");
      console.log("error");
    }
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="keep-mounted-modal-title"
      aria-describedby="keep-mounted-modal-description"
    >
      <Box className="CommentBoxModel">
        <div className="Commentheading">
          <h4>
            {verifystatus === "1" ? "Verify " : "Update "}{" "}
            {updatetype === "2" ? "Email" : "Mobile Number"}
          </h4>
          <button className="CloseModelbtn" onClick={handleClose}>
            <i className="fa fa-times" aria-hidden="true"></i>
          </button>
        </div>

        <div className="leadCommentaddbox">
          <form className="was-validated" encType="multipart/form-data">
            {!ViewVerify ? (
              <>
                <div className="row">
                  <div className="form-group col-lg-8 col-md-6">
                    <input
                      type={updatetype === "2" ? "email" : "text"}
                      value={verifyValue}
                      onChange={(e) => setVerifyValue(e.target.value)}
                      placeholder={`Enter ${
                        updatetype === "2" ? "Email" : "Mobile Number"
                      }`}
                      className="form-control"
                      required={verifystatus !== "1"}
                      readOnly={verifystatus === "1"}
                    />
                  </div>
                  <div className="col-lg-4 col-md-6 text-center mb-3">
                    <button
                      className="theme-btn btn-style-three submitbtn"
                      onClick={handaleGenerate}
                    >
                      OTP Send
                    </button>
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="row">
                  <div className="form-group col-lg-6 col-md-6">
                    <OTPComponent handleEnterOTP={handleEnterOTP} />
                  </div>
                  <div className="col-lg-6 col-md-6 text-center mb-3">
                    <button
                      className="theme-btn btn-style-three submitbtn"
                      onClick={handleSubmit}
                    >
                      {verifystatus === "1" ? "Verify " : "Update "}
                      {updatetype === "2" ? "Email" : "Number"}
                    </button>
                  </div>
                </div>
              </>
            )}
          </form>
        </div>
      </Box>
    </Modal>
  );
}
